export const INSPECTIONKEYSUS = {
  D: {
    columnDefs: [
      {
        field : "inspection_number",
        header: {
          text: "Inspection #",
        },
      },
      {
        field : "inspection_date",
        header: {
          text: "Date",
        },
        pipe: "globalDate",
      },
      {
        field : "display_name",
        header: {
          text: "Customer",
        },
      },
      {
        field : "vehicle",
        header: {
          text: "Vehicle",
        }
      }
    ]
  },
  RA: {
    columnDefs: [
      {
        field : "inspection_number",
        header: {
          text: "Inspection #",
        },
      },
      {
        field : "request_sent_on",
        header: {
          text: "Date Requested",
        },
        pipe    : "globalDate",
        pipeArgs: 'mediumDate'
      },
      {
        field : "display_name",
        header: {
          text: "Customer",
        },
      },
      {
        field : "customer_viewed",
        header: {
          text: "Viewed On",
        },
        pipe    : "globalDate",
        pipeArgs: "MMM d, yyyy h:mm a"
      }
    ]
  },
  A: {
    columnDefs: [
      {
        field : "inspection_number",
        header: {
          text: "Inspection #",
        },
      },
      {
        field : "request_closed_on",
        header: {
          text: "Date Approved",
        },
        pipe: "globalDate",
      },
      {
        field : "display_name",
        header: {
          text: "Customer",
        },
      },
      {
        field : "vehicle",
        header: {
          text: "Vehicle",
        }
      }
    ]
  },
  R: {
    columnDefs: [
      {
        field : "inspection_number",
        header: {
          text: "Inspection #",
        },
      },
      {
        field : "request_closed_on",
        header: {
          text: "Date Refused",
        },
        pipe: "globalDate",
      },
      {
        field : "display_name",
        header: {
          text: "Customer",
        },
      },
      {
        field : "vehicle",
        header: {
          text: "Vehicle",
        }
      }
    ]
  },
  F: {
    columnDefs: [
      {
        field : "inspection_number",
        header: {
          text: "Inspection #",
        },
      },
      {
        field : "request_closed_on",
        header: {
          text: "US Date Finalized Translation",
        },
        pipe: "globalDate",
      },
      {
        field : "display_name",
        header: {
          text: "Customer",
        },
      },
      {
        field : "vehicle",
        header: {
          text: "Vehicle",
        }
      }
    ]
  },
  // Note: not an actual status.
  FW: {
    columnDefs: [
      {
        field : "inspection_number",
        header: {
          text: "Inspection #",
        },
      },
      {
        field : "request_closed_on",
        header: {
          text: "Date Finalized",
        },
        pipe: "globalDate",
      },
      {
        field : "display_name",
        header: {
          text: "Customer",
        },
      },
      {
        field : "vehicle",
        header: {
          text: "Vehicle",
        }
      }
    ]
  },
};
